export default "__VITE_ASSET__CNz6cG17__"